export const template = `Successful {{{data.followup}}} to the chronic care management program of a {{{data.age}}} year old {{{data.gender}}} patient. Patient is {{{data.mentalstatus}}}. Patient is receiving CCM services for the management of {{{data.dx2}}} under the care of {{{data.doctor}}}. Patient presents with a past medical history of {{{data.dx1}}}, and allergies: {{{data.allergies}}}. I spoke with the {{{data.patientcaregiver}}} and we successfully completed the process of completing assessments, medical history and medication review. 

Regarding changes in their physical, mental or emotional health, {{{data.patientcaregiver}}} states {{{data.mentalhealth}}}.  {{{data.patientcaregiver}}} states that they saw his {{{data.physicianfollowup}}} within the {{{data.timeframe}}}. Currently, they are pending {{{data.type}}}. Patient has an upcoming appointment {{{data.upcomingappt}}}. {{{data.patientcaregiver}}} verbalized  {{{data.medications}}} in regards to taking medication as prescribed. Patient has {{{data.medchanges}}} changes in medication.  {{{data.patientcaregiver}}} states they have {{{data.pain}}} pain. The pain is located in {{{data.location}}} with a severity of {{{data.severity}}} and the patient is taking {{{data.painmeds}}} to manage their pain. {{{data.patientcaregiver}}} states they sleep on average {{{data.sleep}}} hours a night.  Patient states they {{{data.meals}}}.  Patient has {{{data.bowels}}} bowel or bladder concerns.  Patient uses {{{data.DME}}} DMEs.  Patient has {{{data.vitals}}} concerns regarding their vitals.  There are {{{data.safety}}} safety concerns at this time.  Patient has had {{{data.emergency}}} emergency room visits since their last follow up. {{{data.extra}}}

Education was provided for {{{data.education}}}. {{{data.patientcaregiver}}} verbalized all the education and I was able to answer any and all questions at this time.  The patient agreed to follow up on a regular basis. Their next scheduled appointment is {{{data.nextapptdate}}} in the {{{data.nextappttime}}}. The patient was advised to call Accuhealth at 1-866-836-7260 or text 78616 should they have any questions, concerns or medical needs before our next scheduled follow up.`;

export const formSections = [
  {
    title: 'Patient Info',
    forms: [
      {
        type: 'MULTIPLE_CHOICE',
        title: 'Type of Appointment',
        id: 'followup',
        hasOtherOption: false,
        isRequired: true,
        choices: ['onboarding appointment', 'follow up appointment'],
        disabled: false,
      },
      {
        type: 'TEXT',
        title: 'Doctor (Include title)',
        id: 'doctor',
        isRequired: true,
        disabled: false,
      },
      {
        type: 'TEXT',
        title: 'Patient Age',
        id: 'age',
        isRequired: true,
        disabled: false,
      },
      {
        type: 'MULTIPLE_CHOICE',
        title: 'Patient Gender',
        id: 'gender',
        hasOtherOption: false,
        isRequired: true,
        choices: ['Male', 'Female'],
        disabled: false,
      },
    ],
  },
  {
    title: 'Past Medical History',
    forms: [
      {
        type: 'CHECKBOX',
        title:
          'Please indicate all CCM qualifying diagnoses \n(Minimum of 2. All diagnoses not listed can be added in "Other")',
        id: 'dx2',
        hasOtherOption: true,
        isRequired: true,
        choices: [
          'Alcohol Abuse',
          'Alzheimer’s Disease',
          'Asthma',
          'Atrial Fibrillation',
          'Autism Spectrum Disorder',
          'Cancer',
          'Chronic Kidney Disease',
          'Chronic Obstructive Pulmonary Disease',
          'Chronic pain',
          'Depression',
          'Diabetes',
          'Down Syndrome',
          'Drug Abuse',
          'Heart Failure',
          'Hepatitis B',
          'Hepatitis C',
          'HIV/AIDS',
          'Hyperlipidemia (High cholesterol)',
          'Hypertension (High blood pressure)',
          'Hypothyroidism',
          'Ischemic Heart Disease',
          'Osteoarthritis',
          'Osteoporosis',
          'Rheumatoid Arthritis',
          'Schizophrenia',
          'Senile Dementia',
          'Substance Abuse',
        ],
        disabled: false,
      },
      {
        type: 'TEXT',
        title:
          'Surgical, Procedures, Other \n(Add all other medical history, including other diagnosis not listed above)',
        id: 'dx1',
        isRequired: false,
        disabled: false,
      },
      {
        type: 'MULTIPLE_CHOICE',
        title: 'List any Allergies in Other (Ex: allergy to penicillin)',
        id: 'allergies',
        hasOtherOption: true,
        isRequired: true,
        choices: ['no known'],
        disabled: false,
      },
    ],
  },
  {
    title: 'Current Patient Status',
    forms: [
      {
        type: 'MULTIPLE_CHOICE',
        title: 'Patient Representative',
        id: 'patientcaregiver',
        hasOtherOption: true,
        isRequired: true,
        choices: ['Patient', "Patient's spouse", "Patient's caregiver"],
        disabled: false,
      },
      {
        type: 'MULTIPLE_CHOICE',
        title:
          'Patient Mental Status  \n(If Other: explain, ex: not alert, oriented, or coherent due to recent hospitalization)',
        id: 'mentalstatus',
        hasOtherOption: true,
        isRequired: true,
        choices: ['alert, oriented, and coherent'],
        disabled: false,
      },
      {
        type: 'MULTIPLE_CHOICE',
        title:
          'Any changes in physical, mental, or emotional health? (If yes, explain in other)',
        id: 'mentalhealth',
        hasOtherOption: true,
        isRequired: true,
        choices: ['there are no changes'],
        disabled: false,
      },
      {
        type: 'TEXT',
        title:
          'Most recent appointment (past) - doctor, clinic, or type of appointment name',
        id: 'physicianfollowup',
        isRequired: true,
        disabled: false,
      },
      {
        type: 'MULTIPLE_CHOICE',
        title: 'Timeframe of most recent appointment',
        id: 'timeframe',
        hasOtherOption: true,
        isRequired: true,
        choices: ['last month'],
        disabled: false,
      },
      {
        type: 'MULTIPLE_CHOICE',
        title: 'Any labs or results pending?\n If yes, specify in "Other"',
        id: 'type',
        hasOtherOption: true,
        isRequired: true,
        choices: ['no labs or studies'],
        disabled: false,
      },
      {
        type: 'TEXT',
        title: 'Upcoming Appointments (Ex: next week with their PCP)',
        id: 'upcomingappt',
        isRequired: true,
        disabled: false,
      },
      {
        type: 'TEXT',
        title:
          'Is the patient taking all of their medications as prescribed? \n(If No, specify why in Other. Ex: Patient cannot afford medication, does not have transportation to pick up medication, etc.)',
        id: 'medications',
        isRequired: false,
        disabled: false,
      },
      {
        type: 'MULTIPLE_CHOICE',
        title: 'Any changes in medication? (If yes, describe in Other)',
        id: 'medchanges',
        hasOtherOption: true,
        isRequired: true,
        choices: ['no'],
        disabled: false,
      },
      {
        type: 'MULTIPLE_CHOICE',
        title:
          "Any concerns regarding patient's vitals since last CCM appointment? (Refer to RPM if they use our services) (If yes, please explain in Other)",
        id: 'vitals',
        hasOtherOption: true,
        isRequired: true,
        choices: ['no'],
        disabled: false,
      },
    ],
  },
  {
    title: 'Narrative',
    forms: [
      {
        type: 'MULTIPLE_CHOICE',
        title: 'Is the patient experiencing any pain? (If yes, leave blank)',
        id: 'pain',
        hasOtherOption: false,
        isRequired: false,
        choices: ['no'],
        disabled: false,
      },
      {
        type: 'TEXT',
        title:
          'Location of pain\n(Be specific, can enter multiple, Ex: Right knee pain)',
        id: 'location',
        isRequired: true,
        disabled: false,
      },
      {
        type: 'TEXT',
        title: 'Severity of pain\n(If multiple locations, put a range, )',
        id: 'severity',
        isRequired: true,
        disabled: false,
      },
      {
        // -
        type: 'MULTIPLE_CHOICE',
        title:
          'Is the patient taking medications for pain management?\n(If yes, specify dose, route, and frequency in Other)',
        id: 'painmeds',
        hasOtherOption: true,
        isRequired: true,
        choices: ['no medication'],
        disabled: false,
      },
      {
        type: 'TEXT',
        title: 'How many hours is patient sleeping on average?',
        id: 'sleep',
        isRequired: true,
        disabled: false,
      },
      {
        type: 'TEXT',
        title:
          'Describe patient diet and percentage of meals consumed. (Ex: Patient finishes 75% of their meal regularly.)',
        id: 'meals',
        isRequired: true,
        disabled: false,
      },
      {
        type: 'MULTIPLE_CHOICE',
        title:
          'Does patient use any DME to perform ADLs? (If yes, specify in Other)',
        id: 'DME',
        hasOtherOption: true,
        isRequired: true,
        choices: ['no'],
        disabled: false,
      },
      {
        type: 'MULTIPLE_CHOICE',
        title:
          'Does patient have any bowel/bladder concerns? (Ex: changes in patterns, incontinence, etc)',
        id: 'bowels',
        hasOtherOption: true,
        isRequired: true,
        choices: ['no'],
        disabled: false,
      },
      {
        type: 'MULTIPLE_CHOICE',
        title:
          'Are there any safety concerns? (fall risk, emergency preparedness, etc) (If yes, describe in Other)',
        id: 'safety',
        hasOtherOption: true,
        isRequired: true,
        choices: ['no'],
        disabled: false,
      },
      {
        type: 'MULTIPLE_CHOICE',
        title: 'Any Emergency Room visits? (If yes, describe in Other)',
        id: 'emergency',
        hasOtherOption: true,
        isRequired: true,
        choices: ['no'],
        disabled: false,
      },
    ],
  },
  {
    title: 'Final Section',
    forms: [
      {
        type: 'TEXT',
        title: 'Education provided',
        id: 'education',
        isRequired: true,
        disabled: false,
      },
      {
        type: 'DATE',
        title: 'Next CCM Appointment date',
        id: 'nextapptdate',
        isRequired: true,
        disabled: false,
      },
      {
        type: 'TEXT',
        title: 'Next CCM Appointment Timeframe (Ex: morning, afternoon)',
        id: 'nextappttime',
        isRequired: true,
        disabled: false,
      },
      {
        type: 'TEXT',
        title:
          'Place any other notes regarding this appointment here to be included in the narrative. (Include health and personal goals) *Use full sentences',
        id: 'extra',
        isRequired: true,
      },
    ],
  },
];
